/**
 * Model definition for page-link-list
 */
export interface PageLinkList {
  __component: 'content.page-link-list';
  reference: {
    linked_pages: [];
  };
  id: string;
  ssr: boolean;
}

export function isPageLinkList(obj: { __component?: string }): obj is PageLinkList {
  return obj.__component === 'content.page-link-list';
}
